


import {CounsellingTopicVM} from './CounsellingTopicVM'; 
import {ReasonForMedicationVM} from './ReasonForMedicationVM'; 
import {HarmingYourselfOrOthers} from './HarmingYourselfOrOthers'; 
export class ClientAssessmentVM {
    
    id?: string;
    
    presentingIssue1?: CounsellingTopicVM;
    
    presentingIssue2?: CounsellingTopicVM;
    
    presentingIssue3?: CounsellingTopicVM;
    
    prescribedMedication?: boolean;
    
    medicationFor1?: ReasonForMedicationVM;
    
    medicationFor2?: ReasonForMedicationVM;
    
    hadPastThoughtsOfEndingLife?: boolean;
    
    everAttemptedToEndYourLife?: boolean;
    
    consideredHarmingYourselfOrOthers?: HarmingYourselfOrOthers;
    
    haveFamilySupport?: boolean;
    
}
